import React from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
function PopRegisterQuestion(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_register_question">
      <h2 className="pop_tit">문제은행 등록하기</h2>
      <div className="content_container scroll">
        <div className="sec_top">
          <div className="com_input_wrap flex_row">
            <select className="select xs">
              <option value="학년 선택">학년 선택</option>
            </select>
            <select className="select xs">
              <option value="과목 선택">과목 선택</option>
            </select>
            <select className="select xs wl">
              <option value="내용 선택">내용 선택</option>
            </select>
          </div>
          <div className="com_input_wrap flex_row">
            <select className="select xs">
              <option value="대제목 선택">대제목 선택</option>
            </select>
            <select className="select xs">
              <option value="증제목 선택">증제목 선택</option>
            </select>
            <select className="select wl">
              <option value="소제목 선택">소제목 선택</option>
            </select>
            <select className="select xs wl">
              <option value="점수3">점수3</option>
            </select>
            <select className="select xs wl">
              <option value="문항수 3">문항수 3</option>
            </select>
          </div>
          <div className="com_input_wrap flex_row">
            <select className="select xs">
              <option value="학평이상">학평이상</option>
            </select>
            <select className="select xs">
              <option value="유출 년도 선택">유출 년도 선택</option>
            </select>
          </div>
        </div>
        <hr className="com_divider" />

        <div className="com_board_box">
          <div className="check_wrap">
            <span className="com_check_box">
              <input type="checkbox" name="chk" id="chk010" className="com_chk" />
              <label htmlFor="chk010">체인숨김</label>
            </span>
            <span className="com_check_box">
              <input type="checkbox" name="chk" id="chk02" className="com_chk" />
              <label htmlFor="chk02">노트플라이</label>
            </span>
            <span className="com_check_box">
              <input type="checkbox" name="chk" id="chk03" className="com_chk" />
              <label htmlFor="chk03">스캔문제</label>
            </span>
            <span className="com_check_box">
              <input type="checkbox" name="chk" id="chk04" className="com_chk" />
              <label htmlFor="chk04">해설 있음</label>
            </span>
          </div>
          <div className="com_input_wrap flex_row">
            <input type="text" className="input xs" defaultValue={`정답률  : 78%`} />
            <select className="select xs">
              <option value="6등급">6등급</option>
              <option value="5등급">5등급</option>
            </select>
          </div>
          <div className="subject">선지 선택률</div>
          <div className="com_btn_wrap percent">
            <div className="com_btn xs line lightGray">
              ① : <span className="cnt">10%</span>
            </div>
            <div className="com_btn xs line lightGray">
              ② : <span className="cnt">50%</span>
            </div>
            <div className="com_btn xs line lightGray">
              ③ : <span className="cnt">5%</span>
            </div>
            <div className="com_btn xs line lightGray">
              ④ : <span className="cnt">10%</span>
            </div>
            <div className="com_btn xs line lightGray">
              ⑤ : <span className="cnt">10%</span>
            </div>
          </div>
          <input type="text" className="input" defaultValue={`고3 2018년 수능 한국사 1번`} />
          <div className="contents">
            (에디터)
            <p className="bold">@ES1711-01 1. 1)</p>
            <p className="bold">(가) 시대에 대한 탐구 활동으로 가장 적절한 것은?</p>
            <p>
              ① 주먹도끼의 용도를 알아본다. <br />
              ② 철제 갑옷의 제작 기법을 살펴본다. <br />
              ③ 금관이 출토된 고분에 대해 조사한다. <br />
              ④ 비파형 동검의 형태적 특징을 분석한다.
              <br />⑤ 빗살무늬 토기의 지역별 특색을 비교한다.
            </p>
            <p className="bold com_point_txt">정답: ④</p>
            <p>
              청동기 시대의 이해 <br />
              정답 해설: 제시된 자료는 청동기 시대의 사회 변화와 관련된 수행 평가 보고서이다. 반달 돌칼의 사용, 빈부의 격차와 계급 발생, 고인돌 축조 등을 통해 파악할 수 있다. 청동기 시대에는 비파형 동검, 거친무늬 거울 등 정동으로 된 무기와 제기를 사용하였다.
            </p>
            <p className="bold com_point_txt">오답피하기</p>
            <p>
              청동기 시대의 이해 <br />
              ② 우리나라에서는 청동기 시대에 이어 기원전 5세기경부터 철기 문화를 수용하였다. <br />
              ③ 삼국 시대의 신라 고분에서는 금관이 출토되었다 <br />⑤ 신석기 시대부터 음식물의 조리와 저장을 위해 토가를 제작하였는데, 빗살무늬 토기는 한반도의 신석기 시대를 대표하는 토기이다.
            </p>
          </div>
          <div className="com_input_upload">
            <Upload title="파일 등록" className="com_btn gray xs wl" />
            <p className="file">
              <span className="txt">File name.pdf</span>
              <button type="button" className="btn_del_file" onClick={() => {}}></button>
              <button type="button" className="btn_down" onClick={() => {}}></button>
            </p>
          </div>
          <hr className="com_divider" />
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopRegisterQuestion;
